// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"270":"4c4422dc","338":"44b182a6","825":"538e3f8d","826":"44b182a6"}[chunkId] + ".chunk.css";
};